import { Component, OnInit } from '@angular/core';
import { DialogConfig } from '../dialog/dialog-config';
import { BaseService } from '../../shared/services/base.service';
import { LoaderService } from '../../services/loader.service';
import { AlertsService } from '../../services/alerts.service';
import { DialogRef } from '../dialog/dialog-ref';

@Component({
    selector: 'app-icd-11',
    templateUrl: './icd-11.component.html',
    styleUrls: ['./icd-11.component.scss'],
    standalone: false
})
export class Icd11Component implements OnInit {
  currentData: any = {};

  constructor(
    public config: DialogConfig,
    public baseService: BaseService,
    private loader: LoaderService,
    public alerts: AlertsService,
    public dialog: DialogRef
  ) {
  }
  
  ngOnInit(): void {
    console.log("config ", this.config);
    this.currentData.question = this.config && this.config.data && this.config.data.question ? this.config.data.question : undefined;
    // let args = "uri:icd.who.int/browse10/2019/en/JsonGetRootConcepts?useHtml=true";
    this.getICDData()
    this.currentData.selectedData = [];
  }

  getICDData(child?){
    let args = ''
    if(child){
      args = "query:"+child.mmscode;
    }
    this.loader.showSpinner();
    this.baseService.get("GET_ICD_DATA", args, "icd_resource", "emr").subscribe(data => {
      if (data.errCode == 0 && data.resource && data.resource.length > 0) {
        if(child == undefined)
          this.currentData.rootData = data.resource;
        else{
          child.padding = child.padding == undefined ? 0 : child.padding;
          child.child_data = data.resource;
          child.child_data.forEach(element => {
            if(element.classKind == 'category')
              element.padding = child.padding + 20;
            else
              element.padding = child.padding + 10;
          });
        }
        this.currentData.show_sections = true;
      }else{
        if(child){
          this.selectChild(child, true);
        }else
          this.alerts.error("No data found!!!");
      }
      this.loader.hideSpinner();
    });
  }

  handleKeyEnter(event) {
    let e: any;
    if(event == ''){
      e = this.currentData.filterKey.trim();
    }else if(event.target.value == ''){
      this.currentData.show = false;
      this.currentData.show_sections = true;
      return;
    }else
      e = event.target.value.trim();
    this.currentData.show = false;
    this.currentData.show_sections = true;
    // this.currentData.searchedData = undefined;
    if (this.currentData.searchedData == undefined || (this.currentData.searchedData != undefined && this.currentData.searchedData != e)) {
      this.loader.showSpinner();
      this.currentData.searchedData = e;
      this.currentData.triggered = true;
      this.baseService.action({"searchValue": this.currentData.searchedData,"includePostcoordination":true}, "SEARCH_ICD_DATA", "emr", "icd_resource", ).subscribe(data => {
        if (data.errCode == 0 && data.resource && data.resource.length > 0) {
          this.currentData.searchData = data.resource[0].destinationEntities;
          this.currentData.show = true;
          this.currentData.show_sections = false;
        }
      this.loader.hideSpinner();
      });
    }else{
      this.currentData.show = true;
      this.currentData.show_sections = false;
    }
    if(event != '' && event != null && event != undefined)
      event.preventDefault();
  }

  getChild(child_data){
    if(child_data.mmscode == undefined){
      let iden = child_data.identifier ? child_data.identifier : child_data.stemId;
      let arr = iden.split('/');
      let code = arr[arr.length -1];
      child_data.mmscode = code;
    }
    if(child_data.child_data == undefined)
      this.getICDData(child_data);
    else{
      if(child_data.hidden == undefined || child_data.hidden == true){
        child_data.hidden = false;
        child_data.child_data.forEach((el, i) => {
          el.selectedNode = false;
          if(el.child_data && el.child_data.length > 0){
            el.hidden = true;
            this.removeDataFromICD(el.child_data);
          }
        });
      } else{
        child_data.hidden = true;
        child_data.child_data.forEach(el => {
          el.selectedNode = true;
        });
      }
    }
  }

  removeDataFromICD(child){
    if(child && child.length > 0){
      child.forEach(el => {
        el.selectedNode = false;
        if(el.child_data && el.child_data.length > 0){
          el.hidden = true;
          this.removeDataFromICD(el.child_data);
        }
      });
    }
  }

  convertToPlain(html) {
    let tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }

  selectChild(item, class_type?){
    if(item.classKind == 'category' || (class_type != undefined && class_type)){
      if(item.selected == undefined || !item.selected){
        item.selected = true;
        if(this.currentData.question){
          let q =this.currentData.question;
          item[q.getterValue] = item.name_ ? (this.convertToPlain(item.name_)).trim() : (this.convertToPlain(item.title)).trim();
          item[q.getterKey] = item.code ? item.code : item.theCode;
        }else{
          item.text = item.name_ ? (this.convertToPlain(item.name_)).trim() : (this.convertToPlain(item.title)).trim();
          item.id = item.code ? item.code : item.theCode;
        }
        item['coding_system'] = 'icd_11';
        if (this.currentData.question && this.currentData.question.defaultsetting && this.currentData.question.defaultsetting.singleSelection) {
          this.dialog.close(item);//single selection enable
        }else
          this.currentData.selectedData.push(item);
      }else{
        item.selected = false;
        let q =this.currentData.question;
        const findIndex = this.currentData.selectedData.findIndex(a => a[q.getterKey] === (item.id = item.code ? item.code : item.theCode));
        this.currentData.selectedData.splice(findIndex, 1);
      }
    }else{
      this.getChild(item);
    }
  }

  toggleSearchBox(){
    this.currentData.show = !this.currentData.show;
    if(this.currentData.show){
      this.currentData.show_sections = false;
      this.currentData.searchedData = undefined;
      this.handleKeyEnter("");
    }
    else
      this.currentData.show_sections = true;
  }

  submitBtn(){
    if(this.currentData.selectedData && this.currentData.selectedData.length > 0)
      this.dialog.close(this.currentData.selectedData); 
    else
      this.alerts.error("Select Item");
  }

}
